
import React, { useEffect, useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { getAllStories } from "../../../../api/summaryReport";

const SprintProgress = () => {

  const [completedPercent, setCompletedPercent] = useState(0);
  const [todoPercent, setTodoPercent] = useState(0);
  const [inProgressPercent, setInProgressPercent] = useState(0);

  useEffect(() => {
    fetchSprintProgress();
  }, []);

  const fetchSprintProgress = async () => {
    try {

      const token = localStorage.getItem("token");
      const res = await getAllStories(token);
      const stories = res.data;

      const today = new Date();

      // Get ACTIVE sprint stories
      const activeSprintStories = stories.filter((story) => {
        if (!story.sprint) return false;

        const start = new Date(story.sprint.startDate);
        const end = new Date(story.sprint.endDate);
        end.setHours(23, 59, 59, 999);

        return today >= start && today <= end;
      });

      let completed = 0;
      let todo = 0;
      let inProgress = 0;

     

      activeSprintStories.forEach((story) => {

        if (!story.storyUsers || story.storyUsers.length === 0) return;

        if (story.status === "COMPLETED") {
          completed++;
        } else if (
          story.status === "INPROGRESS" ||
          story.status === "IN_PROGRESS"
        ) {
          inProgress++;
        } else {
          todo++;
        }
      });

      //const total = activeSprintStories.length;
      const total = activeSprintStories.filter(
        (story) => story.storyUsers && story.storyUsers.length > 0
      ).length;

      
      if (total > 0) {
        //  exact decimals
        const exactTodo = (todo / total) * 100;
        const exactInProgress = (inProgress / total) * 100;
        const exactCompleted = (completed / total) * 100;

        //  floor all
        let todoP = Math.floor(exactTodo);
        let inProgressP = Math.floor(exactInProgress);
        let completedP = Math.floor(exactCompleted);

        //  find remainder
        let remainder = 100 - todoP - inProgressP - completedP;

        // give remainder to highest decimal
        const decimals = [
          { key: "todo", decimal: exactTodo - todoP },
          { key: "inProgress", decimal: exactInProgress - inProgressP },
          { key: "completed", decimal: exactCompleted - completedP },
        ];

        decimals.sort((a, b) => b.decimal - a.decimal);

        for (let i = 0; i < remainder; i++) {
          if (decimals[i].key === "todo") todoP++;
          else if (decimals[i].key === "inProgress") inProgressP++;
          else if (decimals[i].key === "completed") completedP++;
        }

        setTodoPercent(todoP);
        setInProgressPercent(inProgressP);
        setCompletedPercent(completedP);

      } else {
        setTodoPercent(0);
        setInProgressPercent(0);
        setCompletedPercent(0);
      }

    } catch (error) {
      console.error("Error fetching sprint progress", error);
    }
  };

  return (
    <Card className="shadow-sm">

      <Card.Header
        className="text-center fw-semibold"
        style={{ background: "#2d3a4a", color: "#fff", fontSize: "14px" }}
      >
        Sprint Progress
      </Card.Header>

      <Card.Body className="py-3">
        <Row className="align-items-center text-center g-0">

         

          {/* TODO */}
          <Col>
            <div style={{ fontSize: "38px", fontWeight: "700", color: "#dc3545", lineHeight: 1 }}>
              {todoPercent}%
            </div>
            <div style={{ fontSize: "13px", color: "#7f8c9a", marginTop: "6px" }}>
              TODO
            </div>
          </Col>

          {/* Separator */}
          <Col xs="auto">
            <div style={{ width: "1px", height: "55px", background: "#dee2e6" }} />
          </Col>

         
          {/* In Progress */}
          <Col>
            <div style={{ fontSize: "38px", fontWeight: "700", color: "#fd7e14", lineHeight: 1 }}>
              {inProgressPercent}%
            </div>
            <div style={{ fontSize: "13px", color: "#7f8c9a", marginTop: "6px" }}>
              In Progress
            </div>
          </Col>

          <Col xs="auto">
            <div style={{ width: "1px", height: "55px", background: "#dee2e6" }} />
          </Col>


          

          <Col>
            <div style={{ fontSize: "38px", fontWeight: "700", color: "#28a745", lineHeight: 1 }}>
              {completedPercent}%
            </div>
            <div style={{ fontSize: "13px", color: "#7f8c9a", marginTop: "6px" }}>
              Completed
            </div>
          </Col>

        </Row>
      </Card.Body>

    </Card>
  );
};

export default SprintProgress;